var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import './index.scss';
import { Link } from "react-router-dom";
import pubsub from "@viewlift/pubsub";
import { ANALYTICS } from '../../../helpers/analyticsMap';
import { handleNewTabLoader, isTveOnlyLoginEnabled } from "../../../helpers";
import { getFontsStyles } from "../../TrayModules/Helper/helper";
export var LoginButton = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var _s = _a.isVertical, isVertical = _s === void 0 ? false : _s, handleLoader = _a.handleLoader, layoutSettings = _a.layoutSettings, _t = _a.dataTest, dataTest = _t === void 0 ? "" : _t, toggleImg = _a.toggleImg;
    var loginCta = getFontsStyles(layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.fontSetting, layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.settings).loginCta;
    var _u = (layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.settings) || {}, loginCtaBgColor = _u.loginCtaBgColor, loginCtaBorderColor = _u.loginCtaBorderColor, loginCtaTextColor = _u.loginCtaTextColor;
    var isTveOnlyLogin = isTveOnlyLoginEnabled();
    var _v = __read(useState(false), 2), openPopup = _v[0], setPopUp = _v[1];
    var closetoggle = function () {
        setPopUp(false);
    };
    var handleLogin = function () {
        handleLoader();
        pubsub.publish('user-analytics', { ename: ANALYTICS.LOGIN_INIT });
        handleNewTabLoader();
        return true;
    };
    var style = isVertical ? __assign({ textAlign: "center", border: "2px solid #676767", borderRadius: "4px" }, loginCta) : undefined;
    var loginCtaStyle = {
        backgroundColor: loginCtaBgColor,
        color: loginCtaTextColor,
        borderColor: loginCtaBorderColor
    };
    return (React.createElement(React.Fragment, null,
        !isTveOnlyLogin &&
            React.createElement("button", { className: "loginButtonContainer", onBlur: function () {
                    if (toggleImg)
                        toggleImg();
                } },
                React.createElement("div", { className: "loginBtn", style: __assign(__assign({}, style), loginCtaStyle) },
                    React.createElement(Link, { className: "site-color", to: "/authentication", onClick: function () { return handleLogin(); }, "data-test": dataTest }, ((_f = (_e = (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsPlatform) === null || _c === void 0 ? void 0 : _c.navigation) === null || _d === void 0 ? void 0 : _d.settings) === null || _e === void 0 ? void 0 : _e.primaryCta) === null || _f === void 0 ? void 0 : _f.loginCtaText) || 'Login')),
                openPopup && React.createElement(Popup, { toggle: closetoggle })),
        isTveOnlyLogin && React.createElement("div", { className: "loginBtn loginButtonContainer", role: "button", style: __assign(__assign({}, style), loginCtaStyle), tabIndex: 0, "aria-label": ((_l = (_k = (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.app_data) === null || _g === void 0 ? void 0 : _g.appcmsPlatform) === null || _h === void 0 ? void 0 : _h.navigation) === null || _j === void 0 ? void 0 : _j.settings) === null || _k === void 0 ? void 0 : _k.primaryCta) === null || _l === void 0 ? void 0 : _l.loginCtaText) || "link tve provider", onClick: function () { return pubsub.publish('initiate-tve-login-popup', true); } },
            " ", (_r = (_q = (_p = (_o = (_m = window === null || window === void 0 ? void 0 : window.app_data) === null || _m === void 0 ? void 0 : _m.appcmsPlatform) === null || _o === void 0 ? void 0 : _o.navigation) === null || _p === void 0 ? void 0 : _p.settings) === null || _q === void 0 ? void 0 : _q.primaryCta) === null || _r === void 0 ? void 0 :
            _r.loginCtaText)));
};
var Popup = function (_a) {
    var toggle = _a.toggle;
    var App = React.lazy(function () {
        return import('../../../MFEs/web-authentication-sdk/src/AuthenticationWrapper').then(function (module) { return ({
            default: module.AuthenticationWrapper,
        }); });
    });
    return (React.createElement("div", { className: 'popup' },
        React.createElement("div", { className: 'popup_inner' },
            React.createElement(App, null),
            React.createElement("button", { "aria-label": "close", onClick: function () { return toggle(); } }, "Close"))));
};
